import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import api from "../lib/api";
import { ShieldCheck } from "lucide-react";

export default function Terminos() {
  const { setMobileOpen } = useOutletContext();
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/contrato").then(({ data }) => setC(data)).catch(() => {}); }, []);

  return (
    <>
      <Header title="Términos y Condiciones" subtitle="Contrato de Prestación de Servicios de Courier" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 max-w-3xl">
        <div className="bg-white rounded-xl border border-[#E2E8F0] p-6 sm:p-8 shadow-sm space-y-5" data-testid="contrato-doc">
          <div className="flex items-center gap-3 pb-4 border-b border-slate-100">
            <div className="h-11 w-11 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center"><ShieldCheck className="h-5 w-5 text-[#3B82F6]" /></div>
            <div>
              <div className="font-bold text-[#0A1F44] font-display">Pya'elino Courier</div>
              <div className="text-xs text-[#64748B]">Versión {c?.version || "…"} · Última actualización: {c?.fecha || "…"}</div>
            </div>
          </div>
          {!c && <p className="text-sm text-[#64748B]">Cargando contrato…</p>}
          {c && (
            <>
              {c.intro.map((p, i) => <p key={i} className="text-sm text-[#64748B] leading-relaxed">{p}</p>)}
              {c.clausulas.map((cl) => (
                <div key={cl.n} data-testid={`clausula-${cl.n}`}>
                  <h3 className="font-semibold text-[#0A1F44]">{cl.n}. {cl.titulo}</h3>
                  {cl.parrafos.map((p, i) => <p key={i} className="text-sm text-[#64748B] mt-1 leading-relaxed">{p}</p>)}
                </div>
              ))}
            </>
          )}
        </div>
      </main>
    </>
  );
}
